import styled from '@emotion/styled';

const Sixth:React.FC<any>= () => {
  const handleApp = () => {
    window.location.href="/app"
  }

  return (
    // <Container>
    //   <BodyImg>
    //     <Img src="/images/newLanding/home/app.png"/>
    //   </BodyImg>
    //   {/* <Title className="top">사진만 고르면
    //     <br/> 끝이니까<br/>가장 쉬운 인화 신청</Title>
    //   <SmallText>인화부터 관리까지 한 번에,<br/>복잡한 절차는 알아서 해드려요</SmallText> */}
    //   <Title className="top">육퇴 후 사진 보는 시간
    //     <br/>골라 두면 끝
    //     <br/>고민 제로 앱</Title>
    //   <SmallText>인화부터 사진 관리까지 한 번에,<br/>복잡한 절차는 알아서 해드려요</SmallText>
    //   <MoreButtonWrapper>
    //     <MoreButton
    //       onClick={handleApp}
    //     >더 알아보기</MoreButton>
    //   </MoreButtonWrapper>
    // </Container>
    <Container>
      <BodyImg>
        <Img src="/images/newLanding/home/app.png"/>
      </BodyImg>
      {/* <Title className="top">사진만 고르면
        <br/> 끝이니까<br/>가장 쉬운 인화 신청</Title>
      <SmallText>인화부터 관리까지 한 번에,<br/>복잡한 절차는 알아서 해드려요</SmallText> */}
      <Title className="top">
        불필요한 노력 없이도 
        <br/>보장되는 최고의 퀄리티
      </Title>
      <SmallText>
        업로드로 끝나는 인화신청으로
        <br/>매달 선물같은 사진을 받아보세요.
      </SmallText>
      <SmallText>
        트렌디한 앨범, 최고급 반광 인화 용지로
        <br/>고민없이 나만의 앨범을 완성하세요.
      </SmallText>
      <MoreButtonWrapper>
        <MoreButton
          onClick={handleApp}
        >더 알아보기</MoreButton>
      </MoreButtonWrapper>
    </Container>
  )
};

export default Sixth;

const Container = styled.div`
  width: 100%;
  /* background-color: #f2ecdd; */
  background-color: #FBF7F0;
  min-height: 100vh;
`;

const BodyImg = styled.div`
  width: 100%;
`;

const Img = styled.img`
  width: 100%;
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  line-height: 1.5;
  &.top{
    margin: 40px 20px 30px;
  }

  &.bottom {
    margin: 50px 20px 30px;
  }
`;

const SmallText = styled.div`
  font-size: 16px;
  margin: 30px 20px;
  line-height: 1.4;
`;

const MoreButtonWrapper= styled.div`
  margin: 50px auto 120px;
  width: 40%;
  height: 50px;
`

const MoreButton = styled.button`
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: black;
  background-color: rgb(0,0,0,0);
  border: 1px solid rgb(0,0,0,0.2);
  border-radius: 5px;
`;

